import {Controller} from "@hotwired/stimulus";
import {useClickOutside} from "stimulus-use";

export default class extends Controller {
  static targets = ["optionsWrapper", "valueInput"];

  connect() {
    useClickOutside(this);
    this.opened = false;
  }

  clickOutside(event) {
    this.hideOptions();
  }

  toggleOptions() {
    if (!this.hasOptionsWrapperTarget) {
      return;
    }

    if (this.opened === true) {
      this.hideOptions();
    } else {
      this.showOptions();
    }
  }

  showOptions() {
    if (this.opened === true) {
      return
    }

    this.optionsWrapperTarget.classList.add("opened");
    this.opened = true;
  }

  hideOptions() {
    if (this.opened === false) {
      return;
    }

    this.optionsWrapperTarget.classList.remove("opened");
    this.opened = false;
  }

  updateState(event) {
    event.preventDefault();
    this.element.classList.add("updating");

    this.valueInputTarget.value = event.params["state"];
    this.valueInputTarget.form.requestSubmit();
    this.hideOptions();
  }
}
